import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, NumberFormatter, Paper, Stack, Text, rem } from '@mantine/core';
export const CouponsDiscount: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper px={{
    base: 10,
    sm: 16
  }} pb={32} bd="2px dashed #DBFE02" pos="relative">
      <Image src="/assets/wallet/discount.png" w={{
      base: 90,
      sm: 138,
      lg: 114
    }} h={{
      base: 90,
      sm: 126,
      lg: 114
    }} pos="absolute" top={{
      base: rem(-50),
      sm: rem(-70)
    }} left={0} right={0} mx="auto" alt="discount" />

      <Stack align="center" pt={{
      base: 50,
      sm: 60
    }}>
        <Text fz={12} c="var(--text-dark)" fw={700} tt="uppercase">
          {i18n._('Here are the details of your reward:')}
        </Text>

        <Text c="var(--text-dark)" fz={{
        base: 14,
        sm: 21,
        lg: 18
      }} lh={{
        base: rem(16),
        sm: rem(20),
        lg: rem(18)
      }} ta="center" className={gunterzBold.className}>
          {i18n._(`You've received a `)}
          <Text span inherit c="var(--text-prime)">
            <NumberFormatter value={20} suffix="%" />
            {i18n._(' discount')}
          </Text>
          {i18n._(' on your next purchase.')}
        </Text>
      </Stack>
    </Paper>;
};